import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import getClassName from 'src/common/utils/getClassName';
import dateTimeDurationSelector from 'src/inbox/selectors/dateTimeDuration/dateTimeDuration';
import classNames from 'classnames';
import useOfferErrors from 'src/inbox/hooks/useOfferErrors';
import { ImmutableTrip } from '../../../../types/trips/Trips';
import { modified as tripModified } from '../../../helpers';
import DurationSnippet from '../../../../common/components/DurationSnippet';
import {
  REQUESTED_CHANGES_WARNING,
  TRIP_LENGTH_FIELD,
  UNSENT_CHANGES_WARNING,
} from '../../../constants';
import NotificationMessage from '../../../../common/components/NotificationMessage';
import Card from '../../presentation/Card';
import cardStyles from '../../presentation/Card/Card.module.scss';
import styles from './DurationCard.module.scss';

// Import multiple css modules into a component
const s = {
  ...cardStyles,
  ...styles,
};

type Props = {
  trip: ImmutableTrip;
  checkTripModification?: boolean;
  requestedChanges?: boolean;
};

const DurationCard: FC<Props> = ({
  trip,
  // TODO: change how these work
  checkTripModification,
  requestedChanges,
}) => {
  const {
    offerTrip: { durationAsWords, isOfferTripLengthModified },
  } = useSelector(dateTimeDurationSelector(trip.get('pk')));

  const { errors: { duration: invalidDuration } } = useOfferErrors(trip);

  const tripIsModified = Boolean(checkTripModification && tripModified(trip, [TRIP_LENGTH_FIELD]));
  const modified = !!(isOfferTripLengthModified || tripIsModified);

  return (
    <Card
      highlighted={modified}
      withoutMarginBottom
      withDashedBorderBottom
    >
      {!invalidDuration && isOfferTripLengthModified && (
        <NotificationMessage outdent={false}>
          {UNSENT_CHANGES_WARNING}
        </NotificationMessage>
      )}
      {!invalidDuration && !isOfferTripLengthModified && requestedChanges && tripIsModified && (
        <NotificationMessage outdent={false}>
          {REQUESTED_CHANGES_WARNING}
        </NotificationMessage>
      )}
      {invalidDuration && (
        <NotificationMessage outdent={false} variant="error">
          {'Duration needs to be longer than zero. Please set different date(s) and/or departure times.'}
        </NotificationMessage>
      )}
      <DurationSnippet>
        <h3 className={s.heading}>
          Duration
        </h3>
        <p className={getClassName(s, 'details', classNames({
          modified,
        }))}
        >
          {durationAsWords}
        </p>
      </DurationSnippet>
    </Card>
  );
};

export default DurationCard;
